<template>
  <div class="row">
    <div class="col-md-12">
      <p class="clearfix"></p>
      <raffle-campaign-form :route="route"></raffle-campaign-form>
    </div>
  </div>
</template>
<script>
import RaffleCampaignForm from './RaffleCampaignForm.vue'

export default {
  components: {
    RaffleCampaignForm
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/RaffleCampaigns/RaffleCampaignEdit.vue